const fieldContainsLabel = [
  "input",
  "nameAndSurname",
  "contactInfo",
  "address",
  "domain",
  "email",
  "phoneNumber",
  "currency",
];

const fieldContainsPlaceholder = [
  "input",
  "nameAndSurname",
  "contactInfo",
  "address",
  "domain",
  "email",
  "phoneNumber",
  "multi-input",
  "currency",
];

const fieldContainsName = [
  "input",
  "nameAndSurname",
  "contactInfo",
  "address",
  "domain",
  "email",
  "phoneNumber",
  "multi-input",
  "currency",
  "date",
  "dateAndTime",
  "time"
];

const hasFieldContainsLabel = (type: string) => {
  return fieldContainsLabel.includes(type);
};

const hasFieldContainsPlaceholder = (type: string) => {
  return fieldContainsPlaceholder.includes(type);
};

const hasFieldContainsName = (type: string) => {
  return fieldContainsName.includes(type);
};

export {
  hasFieldContainsLabel,
  hasFieldContainsPlaceholder,
  hasFieldContainsName,
};
